export const tableTypes = {
  NETWORKING_MODE: "networking_mode",
  CASE_STUDY_MODE: "case_study_mode",
  GROUP_DISCUSSION_MODE: "group_discussion_mode",
};

export const LiveSessionModes = {
  INSTRUCTOR: "Instructor Mode",
  ACTIVITY: "Activity Mode",
  NETWORKMODE: "Break/Networking Mode",
};

export const LiveSessionEventTypes = {
  SESSION_MODE: "session_mode",
};
